import { makeStyles } from '~/UIKit/Style';
import {
  GRAY_USC,
  GRAY_BACKGROUND,
  DRAWER_INACTIVE_SELECTION,
  PRIMARY_BLUE,
  FITOGRAM_BLUE_EXTRA_LIGHT,
  WHITE,
  PLAIN_GREY,
  RED_USC,
  GRAY_DISABLED,
} from '~/Constants/Colors.constants';
import {
  FONT_SIZE_INBETWEEN,
  FONT_SIZE_MEDIUM,
  FONT_SIZE_MEDIUM_INBETWEEN,
} from '~/Constants/UI.constants';
import { POPOVER_SHADOW } from '~/Constants/CSS.constants';

export const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
  magiclineCardContent: {
    [theme.breakpoints.up('md')]: {
      paddingLeft: 'initial',
      paddingRight: 'initial',
    },
    paddingLeft: 0,
    paddingRight: 0,
  },
  magiclineInnerPadding: {
    paddingLeft: '8px',
    paddingRight: '8px',
    [theme.breakpoints.up('md')]: {
      paddingLeft: 'initial',
      paddingRight: 'initial',
    },
  },
  card: {
    width: '100%',
    boxShadow: '0px 3px 8px 0px rgba(0, 0, 0, 0.12)',
    margin: '8px 0px',
    borderRadius: '0',
    padding: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      margin: '8px 0px',
      borderRadius: '6px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingRight: theme.spacing(6),
      paddingLeft: theme.spacing(6),
      marginBottom: '25px',
    },
  },
  heading: {
    fontWeight: 'bold',
    marginBottom: theme.spacing(2),
  },
  sectionDisabled: {
    color: `${GRAY_USC}`,
  },
  description: {
    fontSize: FONT_SIZE_INBETWEEN,
    marginBottom: theme.spacing(2),
  },
  descriptionSection: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingRight: '16px',
    marginBottom: theme.spacing(2),
    fontSize: FONT_SIZE_INBETWEEN,
  },
  titleSection: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingRight: '16px',
  },
  showDetails: {
    display: 'flex',
    fontSize: FONT_SIZE_INBETWEEN,
    alignItems: 'center',
    color: `${PRIMARY_BLUE}`,
    marginBottom: '16px',
    fontWeight: '700',
    cursor: 'pointer',
    '& svg': {
      color: `${PRIMARY_BLUE}`,
      marginLeft: '4px',
    },
  },
  inputRoot: {
    borderBottom: `1px solid ${DRAWER_INACTIVE_SELECTION}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1),
    userSelect: 'none',
  },
  cursorPointer: {
    cursor: 'pointer',
  },
  selectLabel: {
    fontSize: FONT_SIZE_MEDIUM,
    fontWeight: 'bold',
    marginRight: theme.spacing(1),
  },
  selectedItems: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginTop: theme.spacing(1),
    justifyContent: 'flex-end',
  },
  selectedItem: {
    marginRight: theme.spacing(1),
    whiteSpace: 'nowrap',
  },
  setupInput: {
    border: 'none',
    outline: 'none',
    fontSize: '17px',
    textAlign: 'right',
    fontWeight: '400',
    width: '100%',
    background: 'transparent',
    [theme.breakpoints.up('md')]: {
      width: '400px',
    },
  },
  arrowIcon: {
    color: `${PLAIN_GREY}`,
  },
  crossIcon: {
    width: '22px',
    height: '22px',
    marginLeft: '5px',
  },
  tokenList: {
    marginTop: theme.spacing(2),
    listStyle: 'none',
    background: `${WHITE}`,
    padding: 0,
  },
  listItem: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(1),
    borderBottom: `1px solid ${DRAWER_INACTIVE_SELECTION}`,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  },
  listItemTitle: {
    fontSize: FONT_SIZE_MEDIUM_INBETWEEN,
    fontWeight: 'bold',
  },
  listItemTitleSpan: {
    fontSize: FONT_SIZE_INBETWEEN,
    fontWeight: 'normal',
    marginLeft: '8px',
    color: `${GRAY_USC}`,
  },
  token: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    marginTop: '16px',
    justifyContent: 'flex-end',
    [theme.breakpoints.up('sm')]: {
      width: 'initial',
      marginTop: 'initial',
      justifyContent: 'initial',
    },
  },
  copyIcon: {
    cursor: 'pointer',
    marginLeft: theme.spacing(1),
  },
  popover: {
    display: 'flex',
    position: 'absolute',
    flexDirection: 'column',
    right: '0',
    transition:
      'opacity 336ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 224ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    borderRadius: '4px',
    boxShadow: `${POPOVER_SHADOW}`,
    width: '400px',
    minWidth: '300px',
    outline: '0',
    overflowY: 'auto',
    [theme.breakpoints.down('md')]: {
      position: 'fixed',
      top: '0!important',
      left: '0!important',
      bottom: '0',
      right: '0',
      width: '100%',
      height: '100%',
      maxWidth: '100%',
      maxHeight: '100%',
    },
  },
  popoverPaper: {
    display: 'flex',
    position: 'absolute',
    flexDirection: 'column',
    right: '0',
    transform: 'translateX(8px)',
    transition:
      'opacity 336ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 224ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    borderRadius: '4px',
    boxShadow: `${POPOVER_SHADOW}`,
    width: '400px',
    minWidth: '300px',
    outline: '0',
    overflowY: 'auto',
    maxHeight: '473px',
    [theme.breakpoints.down('md')]: {
      position: 'fixed',
      top: '0!important',
      left: '0!important',
      bottom: '0',
      right: '0',
      width: '100%',
      height: '100%',
      maxWidth: '100%',
      maxHeight: '100%',
    },
  },
  uscCategories: {
    [theme.breakpoints.up('md')]: {
      minWidth: '200px',
      width: '200px',
      maxHeight: '473px',
    },
  },
  magicLineLocations: {
    [theme.breakpoints.up('md')]: {
      width: '362px',
      top: '50%!important',
      maxHeight: '345px',
    },
  },
  popOverListItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
    borderBottom: `1px solid ${DRAWER_INACTIVE_SELECTION}`,
  },
  uscCategoryItem: {
    cursor: 'pointer',
    [theme.breakpoints.up('md')]: {
      borderBottom: 'none',
    },
  },
  locationHeading: {
    marginTop: '32px',
  },
  categoryWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    borderBottom: `1px solid ${DRAWER_INACTIVE_SELECTION}`,
  },
  inportSpot: {
    padding: '8px',
    paddingTop: 0,
  },
  inputMagicline: {
    padding: theme.spacing(2),
    paddingLeft: '8px',
    paddingRight: '8px',
    paddigBottom: 0,
    display: 'flex',
    justifyContent: 'center',
    userSelect: 'none',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
  magiclineDescription: {
    marginRight: '32px',
    [theme.breakpoints.up('md')]: {
      marginRight: 'initial',
    },
  },
  inputCalendar: {
    paddingLeft: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    paddingTop: theme.spacing(1),
    position: 'relative',
  },
  uscConnectDateInput: {
    position: 'relative',
  },
  removeDate: {
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      width: '37px',
      height: '42px',
      right: '5px',
      top: '50%',
      background: `${WHITE}`,
      transform: 'translateY(-50%)',
      '& .endDateCrossIcon': {
        width: '22px',
        height: '22px',
      },
      '& svg': {
        color: `${PLAIN_GREY}`,
        width: '1em',
        cursor: 'pointer',
        zIndex: '100',
      },
    },
    display: 'none',
  },
  popOverSearch: {
    width: '100%',
    background: `${FITOGRAM_BLUE_EXTRA_LIGHT}`,
    borderBottom: `1px solid ${DRAWER_INACTIVE_SELECTION}`,
    padding: '11px 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.up('md')]: {
      width: '362px',
    },
  },
  popOverSearchInput: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    background: `${WHITE}`,
    border: '1px solid #adadb880',
    borderRadius: '25px',
    color: `${GRAY_USC}`,
    fontSize: '18px',
    padding: '5px',
  },
  searchInput: {
    '&::placeholder': {
      color: `${GRAY_USC}`,
    },
    width: '100%',
    fontSize: '15px',
    lineHeight: '16px',
    padding: '0 5px',
    borderRadius: '25px',
    borderColor: '#adadb880',
    color: `${GRAY_USC}`,
    border: 'none',
    outline: 'none',
    background: 'transparent',
  },
  closePopOver: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  baseUrlInput: {
    textDecoration: 'underline',
    color: `${PRIMARY_BLUE}`,
  },
  itemDisabled: {
    background: `${GRAY_BACKGROUND}`,
  },
  categoryCard: {
    padding: '8px',
  },
  modalParagraph: {
    marginBottom: '16px',
  },
  confirmationParagraph: {
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      color: `${RED_USC}`,
      marginRight: '5px',
      width: '20px',
    },
  },
  clearRightSpace: {
    right: -2,
  },
  selectItemIcon: {
    marginTop: '8px',
  },
  categoryBtnSection: {
    height: 100,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  switchRoot: {
    width: 42,
    height: 22,
    padding: 0,
    margin: theme.spacing(1.5),
    marginLeft: 0,
    marginRight: 0,
  },
  switchBase: {
    padding: 1,
    '&$checked': {
      transform: 'translateX(16px)',
      color: `${PRIMARY_BLUE}`,
      '& + $track': {
        backgroundColor: `${PRIMARY_BLUE}`,
        opacity: '1',
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: `${PRIMARY_BLUE}`,
      border: `6px solid ${WHITE}`,
    },
  },
  thumb: {
    width: 20,
    height: 20,
    background: `${WHITE}`,
  },
  track: {
    borderRadius: 13,
    border: `1px solid ${GRAY_DISABLED}`,
    backgroundColor: `${GRAY_DISABLED}`,
    opacity: '1!important',
    transition: 'background-color 0.3s, border 0.3s',
  },
  containerRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column',
      paddingRight: '10px',
      paddingLeft: '0',
    },
  },
  defaultMedium: {
    height: 35,
    letterSpacing: 0.5,
    lineHeight: '19px',
    minWidth: 128,
    borderRadius: '3px',
  },
}));
